import { ParsedUrlQuery } from 'querystring';

import { AccessoriesUrlSorting } from '../types';

export const sortingParseParams = (
  query: ParsedUrlQuery
): AccessoriesUrlSorting => {
  const sorting: AccessoriesUrlSorting = {};

  if (query.subject) sorting.subject = query.subject.toString();

  if (query.direction) sorting.direction = query.direction.toString();

  return sorting;
};
